import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import { useEffect, useRef } from "react";
import versionService, { RELEASE_NOTES } from "../../services/versionService";

import React from "react";

function PrivateRoutes() {
  const {
    email,
    isLoggedIn,
    authentication: { isLoading },
  } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const hasCheckedVersionRef = useRef(false);

  console.log("Private Routes isLoading", isLoading);
  console.log("Private Routes email", email);
  console.log("Private Routes isLoggedIn", isLoggedIn);

  // Check version on first render only (when user refreshes) and redirect to dashboard if user hasn't seen this version
  useEffect(() => {
    if (isLoading || !isLoggedIn || hasCheckedVersionRef.current) {
      return;
    }

    hasCheckedVersionRef.current = true;
    const currentVersion = versionService.getCurrentVersion();

    // Only the dashboard can mark a version as seen, and it only does so when
    // it has notes to show. Redirecting for a version without notes would
    // therefore repeat on every load and permanently break deep links
    // (shared COT portfolio roots, /COT-analysis/:root bookmarks).
    if (
      RELEASE_NOTES[currentVersion] &&
      versionService.shouldShowReleaseNotes(currentVersion) &&
      location.pathname !== "/dashboard"
    ) {
      navigate("/dashboard", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isLoggedIn]); // Only run when auth state changes, not on route changes

  if (isLoading) {
    return null;
  }

  console.log("going to render");

  // Send back the whole URL, not just the path, so a shared deep link survives
  // the login round-trip. The hash comes from window.location because pages
  // like the COT portfolio write it with history.replaceState, which react
  // router never observes.
  const from = `${location.pathname}${location.search}${window.location.hash}`;

  return email && isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from }} replace />
  );
}

export default PrivateRoutes;
